import classNames from 'classnames'

import { UploadLoader } from 'assets/icons/upload-loader'
import { useTranslate } from 'lib/tolgee'

import { translations } from './upload-loading.i18n'
import type { UploadLoadingProps } from './upload-loading.types'

import './upload-loading.styles.scss'

export const UploadLoading = ({ currentFile, totalFiles, className, variant = 'default' }: UploadLoadingProps) => {
  const t = useTranslate()

  return (
    <div
      className={classNames('UploadLoading', `UploadLoading--${variant}`, className)}
      role="status"
      aria-live="polite"
    >
      <UploadLoader className="UploadLoading-icon" />
      <span className="UploadLoading-text">{t(translations.uploadingText(currentFile, totalFiles))}</span>
    </div>
  )
}
